import { create, type StoreApi } from 'zustand';

/**
 * Helper function to create type-safe zustand store to manage timeframe state.
 * @param initialState - Initial state of the timeframe store
 * @param actions - Actions to manipulate the timeframe store
 * @internal
 */
export function createTimeframeStore<S extends object, A extends object>(
  initialState: S,
  actions: (set: StoreApi<S>['setState']) => A,
) {
  return create<S & A>()((set) => ({
    ...initialState,
    ...actions(set as StoreApi<S>['setState']),
  }));
}
